
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M19.285 9.75H4.421c-.246 0-.421.21-.421.422v9.14C4 20.262 4.736 21 5.683 21h12.34c.912 0 1.683-.738 1.683-1.688v-9.14c0-.211-.21-.422-.42-.422zm0-1.125c.21 0 .42-.176.42-.422V6.938c0-.915-.77-1.688-1.682-1.688H16.34V3.422c0-.211-.21-.422-.42-.422h-1.403c-.245 0-.42.21-.42.422V5.25H9.609V3.422C9.61 3.21 9.4 3 9.19 3H7.786c-.245 0-.42.21-.42.422V5.25H5.683C4.736 5.25 4 6.023 4 6.938v1.265c0 .246.175.422.42.422h14.865zm-12.991 5.14c0-.683.553-1.236 1.235-1.236h8.647a1.235 1.235 0 010 2.471H7.53a1.235 1.235 0 01-1.235-1.235zm0 3.53c0-.683.553-1.236 1.235-1.236h5.294a1.235 1.235 0 010 2.47H7.53a1.235 1.235 0 01-1.235-1.235z","fill":"#305BF2"}})])
          )
        }
      }
    